import Seo from "components/general/Seo";
import React, { useState } from "react";
import SignIn from "./SignIn";
import SignUp from "./SignUp";

export default function SignInScreen() {
	const [isSignUp, setIsSignUp] = useState(false);
	return (
		<>
			<Seo title="Portal | Abconet" description="Central hub for accessing tools, documents, and resources within the Abconet environment." />
			{isSignUp ? <SignUp setIsSignUp={setIsSignUp} /> : <SignIn setIsSignUp={setIsSignUp} />}
		</>
	);
}
